/**
 * Single source of truth for the CasaOthers knowledge-base taxonomy.
 * Polish deployment: `labelPl` / `introPl` are the primary rendered fields.
 */
const CATEGORIES = [
  {
    id: 'kopen-in-spanje',
    label: 'Kopen in Spanje',
    labelEn: 'Buying in Spain',
    labelPl: 'Kupowanie w Hiszpanii',
    icon: 'Home',
    intro:
      'Alles wat u moet weten over het kopen van een woning in Spanje: het koopproces, hypotheken, nieuwbouw versus bestaande bouw, kosten koper en de juridische kant. Onmisbaar voor iedere Nederlandse of Belgische koper.',
    introEn:
      'Everything you need to know about buying a property in Spain: the purchase process, mortgages, new build vs resale, buyer costs and the legal side. Essential reading for any Dutch or Belgian buyer.',
    introPl:
      'Wszystko, co musisz wiedzieć o zakupie nieruchomości w Hiszpanii: proces zakupu, kredyty hipoteczne, nowe budownictwo a rynek wtórny, koszty nabywcy i aspekty prawne. Niezbędna lektura dla każdego kupującego.',
    tagSuggestions: [
      'koopproces', 'nieuwbouw', 'bestaande bouw', 'hypotheek',
      'kosten koper', 'belastingen', 'juridisch', 'notaris',
    ],
  },
  {
    id: 'investeren',
    label: 'Investeren',
    labelEn: 'Investing',
    labelPl: 'Inwestowanie',
    icon: 'TrendingUp',
    intro:
      'Spanje is een van de meest aantrekkelijke markten voor vastgoedinvesteringen in Europa. Lees over rendementen, verhuurmogelijkheden, marktontwikkelingen en hoe u een tweede woning slim laat renderen.',
    introEn:
      'Spain is one of the most attractive real estate investment markets in Europe. Discover yields, rental opportunities, market trends, and how to make your second home work for you.',
    introPl:
      'Hiszpania to jeden z najbardziej atrakcyjnych rynków inwestycji w nieruchomości w Europie. Poznaj zwroty, możliwości wynajmu, trendy rynkowe i sposoby na opłacalną drugą nieruchomość.',
    tagSuggestions: [
      'rendement', 'verhuur', 'tweede woning', 'marktontwikkelingen',
      'vastgoedinvesteringen', 'roi',
    ],
  },
  {
    id: 'emigreren',
    label: 'Emigreren',
    labelEn: 'Emigrating',
    labelPl: 'Emigracja',
    icon: 'Plane',
    intro:
      'Een nieuw leven aan de Spaanse kust begint met goede voorbereiding. NIE, residentie, zorgverzekering, scholen voor de kinderen, pensioenregelingen — wij leggen alles helder uit.',
    introEn:
      'A new life on the Spanish coast starts with thorough preparation. NIE, residency, healthcare, schools for the kids, pension arrangements — we explain it all clearly.',
    introPl:
      'Nowe życie na hiszpańskim wybrzeżu zaczyna się od dobrego przygotowania. NIE, rezydencja, ubezpieczenie zdrowotne, szkoły dla dzieci, kwestie emerytalne — wszystko jasno wyjaśniamy.',
    tagSuggestions: [
      'nie', 'residentie', 'verhuizen', 'zorg', 'pensioen',
      'scholen', 'belastingen',
    ],
  },
  {
    id: 'regios',
    label: 'Regio\u2019s',
    labelEn: 'Regions',
    labelPl: 'Regiony',
    icon: 'MapPin',
    intro:
      'Costa Blanca, Costa C\u00e1lida en Costa Almer\u00eda. Elke kust heeft zijn eigen karakter, klimaat en levensstijl. Ontdek welke regio bij u past en welke steden en dorpen u moet kennen.',
    introEn:
      'Costa Blanca, Costa C\u00e1lida and Costa Almer\u00eda. Each coast has its own character, climate and lifestyle. Find the region that suits you best and the towns you need to know.',
    introPl:
      'Costa Blanca, Costa C\u00e1lida i Costa Almer\u00eda. Każde wybrzeże ma swój charakter, klimat i styl życia. Odkryj, który region pasuje do Ciebie i które miasta warto poznać.',
    tagSuggestions: ['costa blanca', 'costa calida', 'costa almeria'],
  },
  {
    id: 'lifestyle',
    label: 'Lifestyle',
    labelEn: 'Lifestyle',
    labelPl: 'Styl życia',
    icon: 'Coffee',
    intro:
      'Het Spaanse leven is meer dan alleen vastgoed. Golf, mooie tuinen, zonnige terrassen, fietsen door het binnenland, de beste stranden en restaurants — laat u inspireren door wat Spanje te bieden heeft.',
    introEn:
      'Spanish living is more than just real estate. Golf, beautiful gardens, sun-drenched terraces, cycling through the interior, the best beaches and restaurants — get inspired by everything Spain has to offer.',
    introPl:
      'Hiszpańskie życie to coś więcej niż nieruchomości. Golf, piękne ogrody, słoneczne tarasy, wycieczki rowerowe, najlepsze plaże i restauracje — zainspiruj się tym, co oferuje Hiszpania.',
    tagSuggestions: [
      'golf', 'interieur', 'zwembad', 'tuin', 'restaurants',
      'stranden', 'natuur', 'wandelen', 'fietsen',
    ],
  },
  {
    id: 'praktische-gidsen',
    label: 'Praktische Gidsen',
    labelEn: 'Practical Guides',
    labelPl: 'Praktyczne przewodniki',
    icon: 'BookOpen',
    intro:
      'Concrete how-to artikelen voor het dagelijks leven in Spanje: een bankrekening openen, internet aansluiten, verzekeringen kiezen, een verbouwing aanpakken en energierekeningen begrijpen.',
    introEn:
      'Practical how-to articles for daily life in Spain: opening a bank account, getting internet installed, choosing insurance, renovating your home and understanding energy bills.',
    introPl:
      'Praktyczne artykuły poradnikowe o codziennym życiu w Hiszpanii: otwieranie konta bankowego, podłączenie internetu, wybór ubezpieczenia, remont domu i rozumienie rachunków za energię.',
    tagSuggestions: [
      'verzekeringen', 'notaris', 'bankrekening', 'verbouwen',
      'energie', 'internet',
    ],
  },
];

export const CATEGORY_BY_ID = Object.fromEntries(CATEGORIES.map(c => [c.id, c]));
export const CATEGORY_IDS = CATEGORIES.map(c => c.id);

export default CATEGORIES;
